import { GOAL_OPTIONS } from "./marketing-data";

export const goalDocuments = (documents, goal) =>
    goal === "all" ? documents : documents.filter((d) => d.goals.includes(goal));

export const productTabs = (sections, documents) => [
    { id: "all", label: "All", count: documents.length },
    ...sections
        .map((s) => ({ id: s.id, label: s.label, count: documents.filter((d) => d.section === s.id).length }))
        .filter((t) => t.count > 0),
];

export const resolveTab = (tab, tabs) => (tabs.some((t) => t.id === tab) ? tab : "all");

export const countLine = (count, goal, sectionLabel) => {
    const parts = [`${count} ${count === 1 ? "document" : "documents"}`];
    if (goal !== "all") parts.push(`for “${GOAL_OPTIONS.find((g) => g.id === goal).label.toLowerCase()}”`);
    if (sectionLabel) parts.push(`in ${sectionLabel}`);
    return parts.join(" ");
};
